export const sxStyled = theme => ({
  root: {
    height: '111vh',
    bgcolor: 'rgba(0, 0, 0, 0.1)',
  },

  container: {
    width: { xs: '100%', sm: '50%' },
    height: { xs: '100vh' },
  },

  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
  },

  progress: {
    mt: '1rem',
    alignSelf: 'center',
  },

  imageContainer: {
    height: '80vh',
    bgcolor: theme.primary,
    display: { xs: 'none', sm: 'block' },
  },
});
